<template>
  <h4 :style="{ fontSize: '1em' }">No results found</h4>
</template>
<script>
export default {};
</script>
